





















































import { defineComponent, onBeforeUnmount, onMounted } from '@vue/composition-api';
import { APP_NAME } from '@/environment';

export default defineComponent({
  name: 'Landing',
  setup() {
    const novaUrl = 'https://painface.net/app/';
    onMounted(() => document.body.classList.add('landing-page'));
    onBeforeUnmount(() => document.body.classList.remove('landing-page'));
    const people = [
      { name: 'Eric McCoy', role: 'Master annotator and scorer.', image: '/images/team/eric-mccoy.jpg' },
      { name: 'SK Park', role: 'PainFace software and machine learning.', image: '/images/team/sk-park.jpg' },
      { name: 'Mark Zylka', image: '/images/team/mark-zylka.jpg', url: 'https://zylkalab.org/' },
      { name: 'Jeff Mogil', image: '/images/team/jeff-mogil.jpg', url: 'https://mogilab.ca/' },
    ];
    const resources = [
      { type: 'MP4 / IMAGING GUIDE', title: 'How to use the PainFace imaging setup', url: 'https://img1.wsimg.com/blobby/go/e0a8cb0f-1c0a-4fc4-a673-7d8b62b6546a/downloads/PainFaceDataAcq_6_9_21_WaterMarked_MaxCompress.mp4?download=1' },
      { type: 'MP4 / SAMPLE DATA', title: 'Baseline sample video', url: 'https://img1.wsimg.com/blobby/go/e0a8cb0f-1c0a-4fc4-a673-7d8b62b6546a/downloads/20220105_Base2_10sC1.mp4?download=1' },
      { type: 'CSV / SAMPLE OUTPUT', title: 'Evaluation output from the baseline sample video', url: 'https://img1.wsimg.com/blobby/go/e0a8cb0f-1c0a-4fc4-a673-7d8b62b6546a/downloads/2022-08-08_rahul_20220105_Base2_10sC1.mp4_f5b1.csv' },
    ];
    const references = [
      { text: 'Langford et al. (2010) — Original Mouse Grimace Scale', url: 'https://pubmed.ncbi.nlm.nih.gov/20453868/' },
      { text: 'Tuttle et al. (2018) — Automated MGS scoring', url: 'https://pubmed.ncbi.nlm.nih.gov/29546805/' },
      { text: 'McCoy et al. (2024) — PainFace development and validation', url: 'https://pubmed.ncbi.nlm.nih.gov/39024163/' },
      { text: 'McCoy et al. (2025) — White-coated mice', url: 'https://pubmed.ncbi.nlm.nih.gov/40705695/' },
    ];
    function scrollTo(id: string) {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    return { APP_NAME, novaUrl, people, resources, references, year: new Date().getFullYear(), scrollTo };
  },
});
